import React, { useState } from 'react';
import _ from 'lodash';
import NumericInput from '../Input';

import './DebouncedNumericPicker.scss';

const noop = () => { };

/**
 * @param {{
 *  value: number;
 *  format: (value: number) => string;
 *  onChange: (value: number, target: string) => void;
 *  style?: React.CSSProperties;
 *  label?: string;
 *  classes?: *;
 *  step?: number;
 *  min?: number;
 *  max?: number;
 *  wit?: number;
 *  disabled?: boolean;
 *  target?: string;
 *  precision?: number;
 * }} param0
 */
const DebouncedNumericPicker = ({
    value: inputValue,
    format = (num) => num,
    min = 0,
    max = 999,
    step = 1,
    style = {},
    classes = {},
    onChange = noop,
    wait = 300,
    disabled,
    target,
    precision,
    ...props
}) => {
    precision = precision ?? 0;
    target = target ?? "";
    disabled = disabled ?? false;
    
    const debouncedOnChangeHandler = React.useCallback(
        _.debounce((value) => {
            setValue(value);
            onChange(value, target);
        }, wait),
        [],
    );

    const [value, setValue] = useState(inputValue);

    return (
        <div className="dnp-container">
            <div style={{ display: 'inline-block' }} className={classes?.container}>
                <NumericInput
                    {...props}
                    min={min}
                    max={max}
                    step={step}
                    precision={precision}
                    value={value}
                    strict={true}
                    handleChangeInput={debouncedOnChangeHandler}
                    style={style ? style : { input: { width: '42px' } }}
                    format={format}
                    isDisabled={disabled}
                />
            </div>
        </div>
        
    );
};

export default DebouncedNumericPicker;
